import React, { useState } from 'react';
import PropTypes from 'prop-types';
// material-ui
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FieldLevelValidation } from './../Validation/FieldLevelValidation';
// css
import './FormField.scss';

const FormField = ({
    name, label, type, placeholder, multiline, disabled, row, select, maxLength,
    value, onChange, multipleValue, multiple, children, onBlur, validate, autoFocus
}) => {

    let required = '';

    if (validate && validate.length > 0) {
        required = validate.some(item => item === 'required') ? 'required' : '';
    }

    const [error, setError] = useState([]);
    const [showError, setShowError] = useState(true);
    
    const handleValidation = (e) => {
        let error = FieldLevelValidation(validate, e.target.value);
        let temp = error.filter(val => val !== undefined);
        onChange(e, temp.length > 0);
        setError(temp);
        setShowError(false);
    };
    
    const onShowError = (e) => {
        onBlur();
        let error = FieldLevelValidation(validate, e.target.value);
        let temp = error.filter(val => val !== undefined);
        setError(temp);
        setShowError(true);
    }

    if(select) {
        return (
            <div className="position-r">
                <TextField
                    select
                    className={`FormField SelectField ${required}`}
                    label={label}
                    value={multiple ? multipleValue : value}
                    fullWidth
                    onChange={(e) => {
                        handleValidation(e);
                    }}
                    onBlur={(e) => onShowError(e)}
                    inputProps={{
                        name: name,
                        maxLength: maxLength
                    }}
                    InputLabelProps={{
                        shrink: true,
                        classes: {
                            root: 'label-root',
                            focused: 'label-focused',
                        }
                    }}
                    SelectProps={{
                        startAdornment: value === '' && <InputAdornment className="selectadornment" position="start">Select</InputAdornment>,
                        disableUnderline: true,
                        classes: {
                            root: 'select-root',
                            select: 'form-select'
                        },
                        MenuProps: {
                            className: 'menu-item'
                        }
                    }}
                >
                    { children }
                </TextField>
                {showError && validate && validate.length > 0 && 
                    <div className='error-msg'>
                        {error.length > 0 && error.map((item,index) => (
                            <React.Fragment key={index}>
                                {item && <span>{item}&nbsp;</span>}
                            </React.Fragment>
                        ))}
                    </div>
                }
            </div>
        );
    }
    return (
        <div className="position-r">
            <TextField
                className={`FormField ${required}`}
                fullWidth
                id={name}
                name={ name }
                label={ label }
                type={ type }
                placeholder={ placeholder }
                multiline={ multiline }
                disabled={ disabled }
                rows={ row }
                value={ value }
                onChange={(e) => {
                    handleValidation(e);
                }}
                onBlur={(e) => onShowError(e)}
                autoFocus={autoFocus}
                InputLabelProps={{
                    shrink: true,
                    classes: {
                        root: 'label-root',
                        focused: 'label-focused',
                    }
                }}
                inputProps={{
                    maxLength: maxLength
                }}
                onInput={(e) => {
                    if (type === 'number' && maxLength) {
                        e.target.value = Math.max(0, parseFloat(e.target.value)).toString().slice(0, maxLength)
                    }
                }}
                InputProps={{
                    disableUnderline: true,
                    classes: {
                        root: `input-root ${multiline ? 'multiline' : ''}`,
                        input: 'input-field',
                        focused: 'input-focused'
                    },
                }}
            />
            { validate && validate.length > 0 && 
                <div className='error-msg'>
                    {showError && error.length > 0 && error.map((item,index) => (
                        <React.Fragment key={index}>
                            {item && <span>{item}&nbsp;</span>}
                        </React.Fragment>
                    ))}
                </div>
            }
        </div>
    );
}

FormField.propTypes = {
    name: PropTypes.string,
	label: PropTypes.string,
	type: PropTypes.string,
    placeholder: PropTypes.string,
    multiline: PropTypes.bool,
    disabled: PropTypes.bool,
    row: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    multipleValue: PropTypes.instanceOf(Array),
    multiple: PropTypes.bool,
	children: PropTypes.instanceOf(Array),
    select: PropTypes.bool,
    validate: PropTypes.instanceOf(Array),
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number
};

FormField.defaultProps = {
    name: '',
    label: '',
	type: 'text',    
    placeholder: '',
    multiline: false,
    disabled: false,
    row: '',
    value: '',
    onChange: () => {},
    onBlur: () => {},
    multipleValue: [],
    multiple: false,
	children: null,
    select: false,
    validate: [],
    autoFocus: false,
    maxLength: null
};

export default FormField;


// WEBPACK FOOTER //
// ./common/Forms/FormField/FormField.js